const phImage = "https://static.bigbrain.gg/assets/lol/riot_static/12.17.1/img/champion/Aatrox.webp";

export const CLASS_OPTIONS = [
  { value: "death_knight", label: "Death Knight", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_DeathKnight.jpg" },
  { value: "demon_hunter", label: "Demon Hunter", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_DemonHunter.jpg" },
  { value: "druid", label: "Druid", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Druid.jpg" },
  { value: "evoker", label: "Evoker", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Evoker.jpg" },
  { value: "hunter", label: "Hunter", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Hunter.jpg" },
  { value: "mage", label: "Mage", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Mage.jpg" },
  { value: "monk", label: "Monk", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Monk.jpg" },
  { value: "paladin", label: "Paladin", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Paladin.jpg" },
  { value: "priest", label: "Priest", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Priest.jpg" },
  { value: "rogue", label: "Rogue", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Rogue.jpg" },
  { value: "shaman", label: "Shaman", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Shaman.jpg" },
  { value: "warlock", label: "Warlock", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Warlock.jpg" },
  { value: "warrior", label: "Warrior", img: "https://static.bigbrain.gg/wow/class-icons/ClassIcon_Warrior.jpg" },
];

export const BUILDS_DEFAULT = {
  class: {
    value: "warrior",
    label: "Warrior",
    img: "https://static.bigbrain.gg/assets/lol/riot_static/12.17.1/img/champion/Aatrox.webp",
  },
};

export const SPEC_OPTIONS_DEMON_HUNTER = [
  { value: "havoc", label: "Havoc", img: "https://static.bigbrain.gg/wow/spec-icons/DemonHunter-Havoc.jpg" },
  { value: "vengeance", label: "Vengeance", img: "https://static.bigbrain.gg/wow/spec-icons/DemonHunter-Vengeance.jpg" },
];

export const SPEC_OPTIONS_EVOKER = [
  { value: "augmentation", label: "Augmentation", img: "https://static.bigbrain.gg/wow/spec-icons/Evoker-Augmentation.jpg" },
  { value: "devastation", label: "Devastation", img: "https://static.bigbrain.gg/wow/spec-icons/Evoker-Devastation.jpg" },
  { value: "preservation", label: "Preservation", img: "https://static.bigbrain.gg/wow/spec-icons/Evoker-Preservation.jpg" },
];

export const SPEC_OPTIONS_SHAMAN = [
  { value: "elemental", label: "Elemental", img: "https://static.bigbrain.gg/wow/spec-icons/Shaman-Elemental.jpg" },
  { value: "enhancement", label: "Enhancement", img: "https://static.bigbrain.gg/wow/spec-icons/Shaman-Enhancement.jpg" },
  { value: "restoration", label: "Restoration", img: "https://static.bigbrain.gg/wow/spec-icons/Shaman-Restoration.jpg" },
];

export const SPEC_OPTIONS_HUNTER = [
  { value: "beast_mastery", label: "Beast Mastery", img: "https://static.bigbrain.gg/wow/spec-icons/Hunter-BeastMastery.jpg" },
  { value: "marksmanship", label: "Marksmanship", img: "https://static.bigbrain.gg/wow/spec-icons/Hunter-Marksmanship.jpg" },
  { value: "survival", label: "Survival", img: "https://static.bigbrain.gg/wow/spec-icons/Hunter-Survival.jpg" },
];

export const SPEC_OPTIONS_MAGE = [
  { value: "arcane", label: "Arcane", img: "https://static.bigbrain.gg/wow/spec-icons/Mage-Arcane.jpg" },
  { value: "frost", label: "Frost", img: "https://static.bigbrain.gg/wow/spec-icons/Mage-Frost.jpg" },
  { value: "fire", label: "Fire", img: "https://static.bigbrain.gg/wow/spec-icons/Mage-Fire.jpg" },
];

export const SPEC_OPTIONS_MONK = [
  { value: "brewmaster", label: "Brewmaster", img: "https://static.bigbrain.gg/wow/spec-icons/Monk-Brewmaster.jpg" },
  { value: "mistweaver", label: "Mistweaver", img: "https://static.bigbrain.gg/wow/spec-icons/Monk-Mistweaver.jpg" },
  { value: "windwalker", label: "Windwalker", img: "https://static.bigbrain.gg/wow/spec-icons/Monk-Windwalker.jpg" },
];

export const SPEC_OPTIONS_PRIEST = [
  { value: "discipline", label: "Discipline", img: "https://static.bigbrain.gg/wow/spec-icons/Priest-Discipline.jpg" },
  { value: "holy", label: "Holy", img: "https://static.bigbrain.gg/wow/spec-icons/Priest-Holy.jpg" },
  { value: "shadow", label: "Shadow", img: "https://static.bigbrain.gg/wow/spec-icons/Priest-Shadow.jpg" },
];

export const SPEC_OPTIONS_WARRIOR = [
  { value: "arms", label: "Arms", img: "https://static.bigbrain.gg/wow/spec-icons/Warrior-Arms.jpg" },
  { value: "fury", label: "Fury", img: "https://static.bigbrain.gg/wow/spec-icons/Warrior-Fury.jpg" },
  { value: "protection", label: "Protection", img: "https://static.bigbrain.gg/wow/spec-icons/Warrior-Protection.jpg" },
];

export const SPEC_OPTIONS_ROGUE = [
  { value: "assassination", label: "Assassination", img: "https://static.bigbrain.gg/wow/spec-icons/Rogue-Assassination.jpg" },
  { value: "outlaw", label: "Outlaw", img: "https://static.bigbrain.gg/wow/spec-icons/Rogue-Outlaw.jpg" },
  { value: "subtlety", label: "Subtlety", img: "https://static.bigbrain.gg/wow/spec-icons/Rogue-Subtlety.jpg" },
];

export const SPEC_OPTIONS_PALADIN = [
  { value: "holy", label: "Holy", img: "https://static.bigbrain.gg/wow/spec-icons/Paladin-Holy.jpg" },
  { value: "protection", label: "Protection", img: "https://static.bigbrain.gg/wow/spec-icons/Paladin-Protection.jpg" },
  { value: "retribution", label: "Retribution", img: "https://static.bigbrain.gg/wow/spec-icons/Paladin-Retribution.jpg" },
];

export const SPEC_OPTIONS_WARLOCK = [
  { value: "destruction", label: "Destruction", img: "https://static.bigbrain.gg/wow/spec-icons/Warlock-Destruction.jpg" },
  { value: "affliction", label: "Affliction", img: "https://static.bigbrain.gg/wow/spec-icons/Warlock-Affliction.jpg" },
  { value: "demonology", label: "Demonology", img: "https://static.bigbrain.gg/wow/spec-icons/Warlock-Demonology.jpg" },
];

export const SPEC_OPTIONS_DRUID = [
  { value: "balance", label: "Balance", img: "https://static.bigbrain.gg/wow/spec-icons/Druid-Balance.jpg" },
  { value: "feral", label: "Feral", img: "https://static.bigbrain.gg/wow/spec-icons/Druid-Feral.jpg" },
  { value: "guardian", label: "Guardian", img: "https://static.bigbrain.gg/wow/spec-icons/Druid-Guardian.jpg" },
  { value: "restoration", label: "Restoration", img: "https://static.bigbrain.gg/wow/spec-icons/Druid-Restoration.jpg" },
];

export const SPEC_OPTIONS_DEATHKNIGHT = [
  { value: "blood", label: "Blood", img: "https://static.bigbrain.gg/wow/spec-icons/DeathKnight-Blood.jpg" },
  { value: "frost", label: "Frost", img: "https://static.bigbrain.gg/wow/spec-icons/DeathKnight-Frost.jpg" },
  { value: "unholy", label: "Unholy", img: "https://static.bigbrain.gg/wow/spec-icons/DeathKnight-Unholy.jpg" },
];

export const RAID_DUNGEON_OPTIONS = [
  { value: "all_dungeons", label: "All Dungeons" },
  { value: "manaforge_omega", label: "Manaforge Omega" },
];

export const CASTLE_NATHRIA_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "shriekwing", label: "Shriekwing" },
  { value: "huntsman_altimor", label: "Huntsman Altimor" },
  { value: "hungering_destroyer", label: "Hungering Destroyer" },
  { value: "sun_kings_salvation", label: "Sun King's Salvation" },
  { value: "artificer_xymox_nathria", label: "Artificer Xy'mox" },
  { value: "lady_inerva_darkvein", label: "Lady Inerva Darkvein" },
  { value: "council_of_blood", label: "The Council of Blood" },
  { value: "sludgefist", label: "Sludgefist" },
  { value: "stone_legion_generals", label: "Stone Legion Generals" },
  { value: "sire_denathrius", label: "Sire Denathrius" },
];

export const SANCTUM_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "tarragrue", label: "The Tarragrue" },
  { value: "eye_of_jailer", label: "The Eye of the Jailer" },
  { value: "the_nine", label: "The Nine" },
  { value: "remnant_of_nerzhul", label: "Remnant of Ner'zhul" },
  { value: "soulrender_dormazain", label: "Soulrender Dormazain" },
  { value: "painsmith_raznal", label: "Painsmith Raznal" },
  { value: "guardian_of_the_first_ones", label: "Guardian of the First Ones" },
  { value: "fatescribe_rohkalo", label: "Fatescribe Roh-Kalo" },
  { value: "kelthuzad", label: "Kel'Thuzad" },
  { value: "sylvanas_windrunner", label: "Sylvanas Windrunner" },
];

export const SEPULCHER_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "vigilant_guardian", label: "Vigilant Guardian" },
  { value: "dausegne", label: "Dausegne" },
  { value: "artificer_xymox_sepulcher", label: "Artificer Xy'mox" },
  { value: "prototype_pantheon", label: "Prototype Pantheon" },
  { value: "skolex", label: "Skolex, the Insatiable Ravener" },
  { value: "halondrus", label: "Halondrus the Reclaimer" },
  { value: "lihuvim", label: "Lihuvim, Principal Architect" },
  { value: "anduin_wrynn", label: "Anduin Wrynn" },
  { value: "lords_of_dread", label: "Lords of Dread" },
  { value: "rygelon", label: "Rygelon" },
  { value: "the_jailer", label: "The Jailer" },
];

export const VAULT_OF_THE_INCARNATES = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "eranog", label: "Eranog" },
  { value: "terros", label: "Terros" },
  { value: "the_primal_council", label: "The Primal Council" },
  { value: "sennarth_the_cold_breath", label: "Sennarth, The Cold Breath" },
  { value: "dathea_ascended", label: "Dathea, Ascended" },
  { value: "kurog_grimtotem", label: "Kurog Grimtotem" },
  { value: "broodkeeper_diurna", label: "Broodkeeper Diurna" },
  { value: "raszageth_the_stormeater", label: "Raszageth the Storm-Eater" },
];

export const ABERRUS_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "kazzara", label: "Kazzara, the Hellforged" },
  { value: "amalgamation_chamber", label: "The Amalgamation Chamber" },
  { value: "forgotten_experiments", label: "The Forgotten Experiments" },
  { value: "zaqali_assault", label: "Assault of the Zaqali" },
  { value: "rashok", label: "Rashok, the Elder" },
  { value: "zskarn", label: "The Vigilant Steward, Zskarn" },
  { value: "magmorax", label: "Magmorax" },
  { value: "echo_of_neltharion", label: "Echo of Neltharion" },
  { value: "scalecommander_sarkareth", label: "Scalecommander Sarkareth" },
];

export const AMIRDRASSIL_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "gnarlroot", label: "Gnarlroot" },
  { value: "igira", label: "Igira the Cruel" },
  { value: "volcoross", label: "Volcoross" },
  { value: "council_of_dreams", label: "Council of Dreams" },
  { value: "larodar", label: "Larodar" },
  { value: "nymue", label: "Nymue" },
  { value: "smolderon", label: "Smolderon" },
  { value: "tindral_sageswift", label: "Tindral Sageswift" },
  { value: "fyrakk", label: "Fyrakk the Blazing" },
];

export const NERUBAR_PALACE_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "ulgrax_the_devourer", label: "Ulgrax the Devourer" },
  { value: "the_bloodbound_horror", label: "The Bloodbound Horror" },
  { value: "sikran_captain_of_the_sureki", label: "Sikran, Captain of the Sureki" },
  { value: "rashanan", label: "Rasha'nan" },
  { value: "broodtwister_ovinax", label: "Broodtwister Ovi'nax" },
  { value: "nexus_princess_kyveza", label: "Nexus-Princess Ky'veza" },
  { value: "the_silken_court", label: "The Silken Court" },
  { value: "queen_ansurek", label: "Queen Ansurek" },
];

export const LIBERATION_OF_UNDERMINE_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "vexie_and_the_geargrinders", label: "Vexie and the Geargrinders" },
  { value: "cauldron_of_carnage", label: "Cauldron of Carnage" },
  { value: "rik_reverb", label: "Rik Reverb" },
  { value: "stix_bunkjunker", label: "Stix Bunkjunker" },
  { value: "sprocketmonger_lockenstock", label: "Sprocketmonger Lockenstock" },
  { value: "the_one_armed_bandit", label: "The One-Armed Bandit" },
  { value: "mugzee_heads_of_security", label: "Mug'Zee, Heads of Security" },
  { value: "chrome_king_gallywix", label: "Chrome King Gallywix" },
];

export const MANAFORGE_OMEGA_RAID_OPTIONS = [
  { value: "all_bosses", label: "All Bosses" },
  { value: "plexus_sentinel", label: "Plexus Sentinel" },
  { value: "loomithar", label: "Loom'ithar" },
  { value: "soulbinder_naazindhri", label: "Soulbinder Naazindhri" },
  { value: "forgeweaver_araz", label: "Forgeweaver Araz" },
  { value: "the_soul_hunters", label: "The Soul Hunters" },
  { value: "fractillus", label: "Fractillus" },
  { value: "nexus_king_salhadaar", label: "Nexus-King Salhadaar" },
  { value: "dimensius_the_all_devouring", label: "Dimensius, the All-Devouring" },
];

export const MYTHIC_ENCOUNTER_OPTIONS = [
  { value: "all_dungeons", label: "All Dungeons" },
  { value: "ara_kara_city_of_echoes", label: "Ara-Kara, City of Echoes" },
  { value: "eco_dome_aldani", label: "Eco-Dome Al'dani" },
  { value: "operation_floodgate", label: "Operation: Floodgate" },
  { value: "halls_of_atonement", label: "Halls of Atonement" },
  { value: "priory_of_the_sacred_flame", label: "Priory of the Sacred Flame" },
  { value: "tazavesh_soleahs_gambit", label: "Tazavesh: So'leah's Gambit" },
  { value: "tazavesh_streets_of_wonder", label: "Tazavesh: Streets of Wonder" },
  { value: "the_dawnbreaker", label: "The Dawnbreaker" },
];

export const AFFIX_OPTIONS = [
  { value: "all", label: "All Affixes" },
  { value: "fortified", label: "Fortified" },
  { value: "tyrannical", label: "Tyrannical" },
];

export const COMBINED_HERO_SPEC_OPTIONS = [
  { value: "0", label: "Not Combined Hero & Spec" },
  { value: "1", label: "Combined Hero & Spec" },
];

export const PVP_GAME_MODE_OPTIONS = [
  { value: "solo_shuffle", label: "Solo Shuffle" },
  { value: "2v2", label: "2v2" },
  { value: "3v3", label: "3v3" },
  { value: "rbg", label: "RBG" },
];
